import { FollowUpActionResponseDtoSourceType } from "@/generated/model/followUpActionResponseDtoSourceType";
import type { SortDir } from "@/lib/category-display";

/**
 * The three Follow-up Actions tabs. Open is the default. Kept as a string union
 * (mirroring the generated API enum values) so tab literals compare cleanly in
 * components; cast to the generated enum at the API boundary.
 */
export type FollowUpActionsTab = "open" | "requires-sign-off" | "history";

export const VALID_TABS: FollowUpActionsTab[] = [
  "open",
  "requires-sign-off",
  "history",
];

/** Sort columns supported server-side (must match the API allow-list). */
export type FollowUpActionSortColumn =
  | "action"
  | "category"
  | "type"
  | "dueDate"
  | "assignee"
  | "status";

export const PAGE_SIZE = 10;

/** Default sort per tab when the user hasn't picked a column. */
export const DEFAULT_SORT: Record<
  FollowUpActionsTab,
  { column: FollowUpActionSortColumn; dir: SortDir }
> = {
  open: { column: "dueDate", dir: "asc" },
  "requires-sign-off": { column: "dueDate", dir: "asc" },
  history: { column: "dueDate", dir: "desc" },
};

/** Friendly label for the Type column, derived from the action's source type. */
export function sourceTypeLabel(
  sourceType: FollowUpActionResponseDtoSourceType,
): string {
  switch (sourceType) {
    case FollowUpActionResponseDtoSourceType.QUESTIONNAIRE_ANSWER:
      return "Checklist";
    case FollowUpActionResponseDtoSourceType.COMPLIANCE_TASK_INSTANCE:
      return "Compliance Task";
    case FollowUpActionResponseDtoSourceType.OUT_OF_RANGE_INCIDENT:
      return "Monitoring";
    case FollowUpActionResponseDtoSourceType.EVENT_RECORD:
      return "Event Record";
    case FollowUpActionResponseDtoSourceType.FIRE_EXTINGUISHER_CHECK_ITEM:
    case FollowUpActionResponseDtoSourceType.EMERGENCY_LIGHT_CHECK_ITEM:
      return "Fire Safety";
    case FollowUpActionResponseDtoSourceType.LOG_ENTRY:
      return "Log";
  }
}
